// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3o36z","calendarButtons":"ClockData_calendarButtons__Q_d5N"};